import { useState, useCallback } from 'react'
import { ShareableModule } from '@/lib/api/share/share-api'

interface ShareConfig {
    module: ShareableModule
    moduleLabel: string
    recordId: number
    recordTitle: string
}

export function useShareData() {
    const [isOpen, setIsOpen] = useState(false)
    const [config, setConfig] = useState<ShareConfig | null>(null)

    const openShare = useCallback((shareConfig: ShareConfig) => {
        setConfig(shareConfig)
        setIsOpen(true)
    }, [])

    const closeShare = useCallback(() => {
        setIsOpen(false)
        setConfig(null)
    }, [])

    return {
        isOpen,
        config,
        openShare,
        closeShare,
    }
}

// Mapeamento de modulos para labels
export const MODULE_LABELS: Record<ShareableModule, string> = {
    [ShareableModule.CLIENT]: 'Cliente',
    [ShareableModule.PRODUCT]: 'Produto',
    [ShareableModule.PROFESSIONAL]: 'Profissional',
    [ShareableModule.CATALOG]: 'Catálogo',
    [ShareableModule.PRICE_TABLE]: 'Tabela de Precos',
    [ShareableModule.MEDICATION]: 'Medicamento',
    [ShareableModule.ROOM]: 'Sala',
    [ShareableModule.SPECIALTY]: 'Especialidade',
    [ShareableModule.HEALTH_PLAN]: 'Plano de Saude',
    [ShareableModule.ANAMNESIS_TEMPLATE]: 'Template de Anamnese',
    [ShareableModule.MEDICAL_REPORT_TEMPLATE]: 'Template de Laudo',
    [ShareableModule.INFORMED_CONSENT_TEMPLATE]: 'Template de Consentimento',
    [ShareableModule.DEPARTMENT]: 'Setor',
    [ShareableModule.ATTENDANT]: 'Atendente',
    [ShareableModule.INTEGRATION]: 'Integração',
    [ShareableModule.CONSULTATION]: 'Consulta',
    [ShareableModule.TRIAGE]: 'Triagem',
    [ShareableModule.EXAM]: 'Exame',
    [ShareableModule.PRESCRIPTION]: 'Receita',
    [ShareableModule.PROCEDURE]: 'Procedimento',
    [ShareableModule.EMPLOYEE]: 'Funcionário',
    [ShareableModule.PARTNER]: 'Parceiro',
    [ShareableModule.PRODUCT_CATEGORY]: 'Categoria de Produto',
    [ShareableModule.TISS_CONFIG]: 'Configuração TISS',
    [ShareableModule.PACS_SERVER]: 'Servidor PACS',
    [ShareableModule.PHARMACY_INTEGRATION]: 'Integração Farmácia',
    [ShareableModule.RNDS_CONFIG]: 'Configuração RNDS',
    [ShareableModule.LAB_INTEGRATION]: 'Integração Laboratorial',
}
